import type { ReactNode } from "react"
import type { Props as ReactSelectProps, GroupBase } from "react-select"
import { ERP_CONTROLLED_TOOLTIP } from "~/constants/erpFields"
import Select from "../../reusable/Select"
import { DisabledTooltip } from "../../reusable/DisabledTooltip"
import { ResetButton } from "./ResetButton"
import { FieldRow } from "./FieldRow"
import type { FieldMetadata } from "./types"

type SelectFieldRowProps<
  Option = any,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Omit<ReactSelectProps<Option, IsMulti, Group>, "size"> & {
  label: ReactNode
  badges?: ReactNode
  erpIndicator?: ReactNode
  showResetButton?: boolean
  resetTooltip?: string
  onReset?: () => void
  isFirst?: boolean
  fieldData?: FieldMetadata
}

export const SelectFieldRow = <
  Option = any,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  label,
  badges,
  erpIndicator,
  showResetButton = false,
  resetTooltip,
  onReset,
  isFirst = false,
  fieldData,
  ...selectProps
}: SelectFieldRowProps<Option, IsMulti, Group>) => {
  const lockedByErp = fieldData?.isEditable === false

  return (
    <FieldRow label={label} badges={badges} erpIndicator={erpIndicator} isFirst={isFirst}>
      <div className="flex items-center gap-2 w-full">
        <DisabledTooltip
          title={lockedByErp ? ERP_CONTROLLED_TOOLTIP : undefined}
          wrapperClassName="w-full"
        >
          <Select size="sm" {...selectProps} isDisabled={selectProps.isDisabled || lockedByErp} />
        </DisabledTooltip>
        {showResetButton && onReset && resetTooltip && (
          <ResetButton onClick={onReset} tooltip={resetTooltip} />
        )}
      </div>
    </FieldRow>
  )
}
